import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Partner.css";
import phlona from "../../../images/partners/phlona.png";
import fot from "../../../images/partners/utof.jpeg";
import ecurei from "../../../images/partners/ecurei.jpg";
import kam from "../../../images/partners/kam.jpg";
import { Link } from "react-router-dom";

export default function Partner() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  return (
    <section className="partners-section" aria-labelledby="partners-heading">
      <div className="container">
        {/* Header */}
        <div className="partners-header" data-aos="fade-up">
          <div className="section-label">
            <ion-icon name="people-outline"></ion-icon>
            Trusted Partners
          </div>
          <h2 id="partners-heading">Our Partners &amp; Affiliates</h2>
          <p>
            Partnerships make our services more equitable and accessible. We
            thank our current partners and invite new credible partnerships.
          </p>
        </div>

        {/* Slider */}
        <div className="partner-slider" data-aos="fade-up" data-aos-delay="100">
          <Slider {...settings}>
            <div className="slider-item">
              <img src={ecurei} alt="Ecurei Hospital" />
            </div>
            <div className="slider-item">
              <img src={kam} alt="KAM Partner" />
            </div>
            <div className="slider-item">
              <img src={phlona} alt="Phlona Medical Center" />
            </div>
            {/* <div className="slider-item text-image">
              <div className="text-contents">Phlona Medical Center</div>
            </div> */}
            <div className="slider-item">
              <img src={fot} alt="Medica Partner" />
            </div>
          </Slider>
        </div>

        {/* CTA */}
        <div className="partners-cta" data-aos="fade-up">
          <p>Interested in partnering with Yita Life Medical Services?</p>
          <Link to="/Contact" className="partners-cta-btn">
            <ion-icon name="handshake-outline"></ion-icon>
            Become a Partner
          </Link>
        </div>
      </div>
    </section>
  );
}
